// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/analytics_order_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/analytics_order_response.proto.
 */
export const file_responses_v1_analytics_order_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CityZXNwb25zZXMvdjEvYW5hbHl0aWNzX29yZGVyX3Jlc3BvbnNlLnByb3RvEgxyZXNwb25zZXMudjEiSQoWQW5hbHl0aWNzT3JkZXJSZXNwb25zZRIvCgVpdGVtcxgBIAMoCzIgLnJlc3BvbnNlcy52MS5BbmFseXRpY3NPcmRlckl0ZW0iPQoSQW5hbHl0aWNzT3JkZXJJdGVtEgoKAmlkGAEgASgEEgwKBG5hbWUYAiABKAkSDQoFY291bnQYAyABKA1ChgEKEGNvbS5yZXNwb25zZXMudjFCG0FuYWx5dGljc09yZGVyUmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z'
    );

/**
 * @generated from message responses.v1.AnalyticsOrderResponse
 */
export type AnalyticsOrderResponse = Message<'responses.v1.AnalyticsOrderResponse'> & {
    /**
     * @generated from field: repeated responses.v1.AnalyticsOrderItem items = 1;
     */
    items: AnalyticsOrderItem[];
};

/**
 * Describes the message responses.v1.AnalyticsOrderResponse.
 * Use `create(AnalyticsOrderResponseSchema)` to create a new message.
 */
export const AnalyticsOrderResponseSchema: GenMessage<AnalyticsOrderResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_analytics_order_response, 0);

/**
 * @generated from message responses.v1.AnalyticsOrderItem
 */
export type AnalyticsOrderItem = Message<'responses.v1.AnalyticsOrderItem'> & {
    /**
     * @generated from field: uint64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: string name = 2;
     */
    name: string;

    /**
     * @generated from field: uint32 count = 3;
     */
    count: number;
};

/**
 * Describes the message responses.v1.AnalyticsOrderItem.
 * Use `create(AnalyticsOrderItemSchema)` to create a new message.
 */
export const AnalyticsOrderItemSchema: GenMessage<AnalyticsOrderItem> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_analytics_order_response, 1);
